import React from "react";

interface StarredIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const StarredIcon: React.FC<StarredIconProps> = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.072 17.284L8.16701 19.337C8.00186 19.4238 7.81572 19.4627 7.62962 19.4493C7.44352 19.4358 7.2649 19.3706 7.11394 19.2609C6.96298 19.1513 6.84571 19.0016 6.77539 18.8287C6.70507 18.6559 6.6845 18.4669 6.71601 18.283L7.46101 13.934L4.30201 10.854C4.1686 10.7237 4.07426 10.5587 4.02965 10.3777C3.98504 10.1967 3.99194 10.0068 4.04956 9.82944C4.10717 9.65211 4.21322 9.49442 4.35573 9.37418C4.49823 9.25394 4.67151 9.17593 4.85601 9.14897L9.22201 8.51397L11.175 4.55797C11.2575 4.3905 11.3853 4.24948 11.5438 4.15087C11.7023 4.05226 11.8853 4 12.072 4C12.2587 4 12.4417 4.05226 12.6002 4.15087C12.7587 4.24948 12.8865 4.3905 12.969 4.55797L14.921 8.51397L19.287 9.14897C19.4716 9.17578 19.645 9.25367 19.7876 9.37385C19.9303 9.49403 20.0364 9.6517 20.0942 9.82906C20.1519 10.0064 20.1589 10.1964 20.1143 10.3775C20.0698 10.5586 19.9754 10.7236 19.842 10.854L16.682 13.934L17.428 18.283C17.4594 18.4667 17.4388 18.6556 17.3685 18.8283C17.2982 19.001 17.181 19.1505 17.0302 19.2602C16.8794 19.3698 16.701 19.435 16.5151 19.4486C16.3292 19.4622 16.1431 19.4235 15.978 19.337L12.072 17.284Z"
        fill={fill}
      />
    </svg>
  );
};

export default StarredIcon;
